<sbw-layout
    [backButtonVisible]="false"
    [continueButtonVisible]="false"
    [type]="'Amendment'"
    >
    <div class="row uncollapse bookings-container">
        <div class="column small-12">
            <div class="row">
                <h1>{{ 'MENU_TOP_BOOKINGS' | resource }}</h1>
            </div>
        </div>
        <div class="column small-12">
            <div class="row sbw_agentHome">
                <h2>{{ 'AMENDMENT_MY_ACTIVE_BOOKINGS' | resource }}</h2>
                <div *ngIf="activeBookings">
                    <div *ngIf="!activeBookings.length">{{ 'AMENDMENT_MY_BOOKINGS_NO_ACTIVE_BOOKINGS' | resource }}</div>
                    <sbw-booking-list id="active-bookings" [bookings]="activeBookings" *ngIf="activeBookings.length">
                    </sbw-booking-list>
                </div>
            </div>
        </div>

        <div class="column small-12">
            <div class="row sbw_agentHome">
                <h2>{{ 'AMENDMENT_MY_PREVIOUS_BOOKINGS' | resource }}</h2>
                <div *ngIf="expiredBookings">
                    <div *ngIf="!expiredBookings.length">{{ 'AMENDMENT_MY_BOOKINGS_NO_PREVIOUS_BOOKINGS' | resource }}</div>
                    <sbw-booking-list id="inactive-bookings" [bookings]="expiredBookings" *ngIf="expiredBookings.length">
                    </sbw-booking-list>
                </div>
            </div>
        </div>
    </div>
</sbw-layout>
